<template>
  <b-container v-if="this.$root.token">
    <b-row>
      <b-col class="text-left do-it">
        <router-link to="/scoring-events">
          <b-card overlay
            img-src="/static/Grow-red.png"
            title="Analyse Scoring Events"
            text-variant="white"
          />
        </router-link>
      </b-col>
      <b-col class="text-left do-it align-text-bottom">
        <router-link to="/industry-data">
          <b-card overlay
            img-src="/static/Think-red.png"
            title="Explore Industry Data"
            text-variant="white"
          />
        </router-link>
      </b-col>
    </b-row>
    <b-row class="pt-3">
      <b-col class="text-right do-it">
        <router-link to="/wizard">
          <b-card overlay
            img-src="/static/Ruler-red.png"
            title="Import New Data"
            text-variant="white"
          />
        </router-link>
      </b-col>
      <b-col class="text-right do-it">
        <router-link to="/gpc-sessions">
          <b-card overlay
            img-src="/static/Spanner-red.png"
            title="Dig into the Detail"
            text-variant="white"
          />
        </router-link>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  name: 'Home',
  components: {
  }
}
</script>
<style>
.do-it {
  font-family: Archer, serif;
  font-weight: bold;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue